import { Node, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { nanoid } from 'nanoid'
import { InternalNoteNodeView } from './internal-note-node-view'

export interface InternalNoteAttributes {
  id?: string
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    internalNote: {
      /** Insert an Internal Note block (not published) */
      insertInternalNote: () => ReturnType
    }
  }
}

export const InternalNoteExtension = Node.create({
  name: 'InternalNote',

  group: 'block',
  content: 'block+',
  isolating: true,
  defining: true,

  addAttributes() {
    return {
      id: {
        default: nanoid(10),
        parseHTML: element => element.getAttribute('data-dg-id'),
        renderHTML: attributes => {
          if (!attributes.id) return {}
          return { 'data-dg-id': attributes.id }
        },
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="InternalNote"]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, { 'data-type': 'InternalNote' }),
      0,
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(InternalNoteNodeView)
  },

  addCommands() {
    return {
      insertInternalNote:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: { id: nanoid(10) },
            content: [
              { type: 'paragraph', content: [] },
            ],
          })
        },
    }
  },
})

export default InternalNoteExtension

